<template>
  <div
      class="sidebar"
      :data-color="sidebarItemColor"
      :data-image="sidebarBackgroundImage"
      :style="sidebarStyle"
  >
    <div class="logo">
      <div @click="routeToHome()" class="simple-text logo-mini">
        <div class="logo-img">
          <img :src="imgLogo" alt="" />
        </div>
      </div>

      <div
          @click="routeToHome()"
          class="simple-text logo-normal"
      >
        {{ title }}
      </div>
    </div>
    <div class="sidebar-wrapper">
      <slot name="content"></slot>
      <md-list class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :to="link.path"
              :link="link"
          >
          </sidebar-link>
        </slot>
      </md-list>
    </div>
  </div>
</template>

<script>
import SidebarLink from "@/components/SidebarPlugin/SidebarLink";

export default {
  name: "AdminSideBar",
  components: {
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: "Shon Properties",
    },
    sidebarBackgroundImage: {
      type: String,
      default: require("@/assets/img/sidebar-2.jpg"),
    },
    imgLogo: {
      type: String,
      default: require("@/assets/images/logo.svg"),
    },
    sidebarItemColor: {
      type: String,
      default: "green",
      validator: (value) => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.sidebarBackgroundImage})`,
      };
    },
  },
  methods: {
    routeToHome() {
      if (this.$route.path !== '/admin') {
        this.$router.push('/admin')
      }
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}
</style>
